import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import CommonBubble from '@/pages/home/components/CommonBubble';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import ActiveIcon from '@/pages/home/assets/svg/nacHeader/home-search-active.svg';
import DefaultIcon from '@/pages/home/assets/svg/nacHeader/home-search-default.svg';

const LOCAL_STORAGE_KEY = 'dbh_ai_search_enabled';

export interface IAISearchSwitchButtonLogConfig {
  pageId: string;
  openButtonId: string;
  closeButtonId: string;
  typeId?: string;
  openExtInfo?: string;
  closeExtInfo?: string;
}

interface IAISearchSwitchProps {
  isActive: boolean;
  onChange: (active: boolean) => void;
  buttonLogConfig?: IAISearchSwitchButtonLogConfig;
}

// 获取 LocalStorage 中的 AI Search 状态
export const getAISearchEnabled = (): boolean => {
  try {
    const value = localStorage.getItem(LOCAL_STORAGE_KEY);
    return value === 'true';
  } catch {
    return false;
  }
};

// 设置 LocalStorage 中的 AI Search 状态
export const setAISearchEnabled = (enabled: boolean): void => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, String(enabled));
  } catch {
    // ignore
  }
};

const AISearchSwitch: React.FC<IAISearchSwitchProps> = ({ isActive, onChange, buttonLogConfig }) => {
  const { formatMessage } = useIntl();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    const newValue = !isActive;

    if (buttonLogConfig) {
      buriedBtnPoint({
        buttonId: newValue ? buttonLogConfig.openButtonId : buttonLogConfig.closeButtonId,
        pageId: buttonLogConfig.pageId,
        extInfo: newValue
          ? (buttonLogConfig.openExtInfo || 'AI Search Switch Open')
          : (buttonLogConfig.closeExtInfo || 'AI Search Switch Close'),
        typeId: buttonLogConfig.typeId,
      });
    }

    setAISearchEnabled(newValue);
    onChange(newValue);
  };

  // 根据开关状态显示不同的提示文案
  const tipContent = isActive
    ? formatMessage({ id: 'dbh_ai_search_switch_enabled_hover' })
    : formatMessage({ id: 'dbh_ai_search_switch_open_hover' });

  return (
    <CommonBubble
      content={tipContent}
      placement="left"
      dark
    >
      <div
        className={classnames('dbh-ai-search-switch', {
          'dbh-ai-search-switch--active': isActive,
          'dbh-ai-search-switch--inactive': !isActive,
        })}
        onClick={handleClick}
      >
        <div className="dbh-ai-search-switch__toggle">
          <div className={classnames('dbh-ai-search-switch__toggle-dot', {
            'dbh-ai-search-switch__toggle-dot--active': isActive,
          })} />
        </div>
        <div className="dbh-ai-search-switch__icon">
          <img src={isActive ? ActiveIcon : DefaultIcon} alt="" />
        </div>
      </div>
    </CommonBubble>
  );
};

export default AISearchSwitch;
